import React from 'react';
import { Card as AntCard } from 'antd';
import { CardProps } from 'antd/lib/card';

import cn from 'classnames';
import styles from './Card.module.scss';

import { Grid, ICardGridProps } from './Grid';
import { Meta } from './Meta';

export type { ICardGridProps };

export interface ICardProps extends CardProps {}

type TCard = React.FC<ICardProps> & {
  Grid: typeof Grid;
  Meta: typeof Meta;
};

/**
 * Card component
 */
export const Card: TCard = ({ className, ...props }) => (
  <AntCard className={cn(styles.Card, className)} {...props} />
);

Card.Grid = Grid;
Card.Meta = Meta;
